import { ViewportScroller } from '@angular/common';
import { Component, OnInit, afterNextRender, inject } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-privacy-notice',
  imports: [],
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.scss',
})
export class PrivacyNoticeComponent implements OnInit {
  private readonly viewport = inject(ViewportScroller);
  private readonly seo = inject(SeoService);

  constructor() {
    afterNextRender(() => this.viewport.scrollToPosition([0, 0]));
  }

  ngOnInit() {
    this.seo.setPageSeo({
      title: 'Adatkezelési tájékoztató – Kanyar Büfé',
      description:
        'Kanyar Büfé adatkezelési tájékoztató. Az oldal tartalma feltöltés alatt.',
      canonical: 'https://kanyarbufe.hu/adatkezelesi-tajekoztato',
      // Üres tartalom – ne kerüljön az indexbe, amíg fel nem töltjük.
      noindex: true,
    });
  }
}
